// Not all Survey Points are Alignment Points and Not all Alignment Points are Survey Points
// Alignment Points which define the geometry are Survey Points (IP and Key Points)
export var AlignmentPointType;
(function (AlignmentPointType) {
    AlignmentPointType["INTERSECTION_POINT"] = "intersection_point";
    AlignmentPointType["BEGIN_POINT"] = "begin_point";
    AlignmentPointType["END_POINT"] = "end_point";
    AlignmentPointType["STATION_POINT"] = "station_point";
    AlignmentPointType["POINT_OF_VERTICAL_INTERSECTION"] = "point_of_vertical_intersection";
    //Non-standard points
    AlignmentPointType["IP_PROJECTION"] = "ip_projection";
    AlignmentPointType["TRACE_POINT"] = "trace_point";
    AlignmentPointType["GEOMETRIC_POINT"] = "geometric_point";
    AlignmentPointType["BEGIN_CURVE_POINT"] = "begin_curve_point";
    AlignmentPointType["END_CURVE_POINT"] = "end_curve_point";
})(AlignmentPointType || (AlignmentPointType = {}));
//# sourceMappingURL=interface.js.map